import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Navbar.css";
import { useAppTranslation } from "../../Utils/useAppTranslation";
import Registration from "../User/Register/register";
import UserLogin from "../User/loginuser/userlogin";
import { Modal, Button, Form } from 'react-bootstrap';
import { getAllDataWithFlag, userChangepassword } from "../../services/CommonService";
import moment from "moment";
import Swal from "sweetalert2";


// import Registration from '../Register/register';
// import UserLogin from "../User/loginuser/userlogin";

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isAdminRoute = location.pathname.startsWith("/admin");
  const [menuOpen, setMenuOpen] = useState(false);
  const [userData, setuserData] = useState(null);
  const [isSticky, setIsSticky] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showRegistrationModal, setShowRegistrationModal] = useState(false);
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errors, setErrors] = useState({});
  const { t } = useAppTranslation();
  const [hasEvent, setHasEvent] = useState(false);
  const [news, setNews] = useState(null)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showOldPassword, setShowOldPassword] = useState(false);



  const strongPasswordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  // Fetch existing projects data
  useEffect(() => {
    const intervalId = setInterval(() => {
      const userdata = localStorage.getItem('usercre');
      if (userdata) {
        try {
          const parsed = JSON.parse(userdata);
          if (parsed) {
            setuserData(parsed);
            clearInterval(intervalId); // ✅ Stop polling once data is found and set
          } else {
            console.error('');
          }
        } catch (e) {
          console.error('Invalid JSON in menuData:', e);
        }
      }
    }, 500); // 🔁 Check every 500ms
  }, []);



  useEffect(() => {
    if (errors?.confirmPassword) {
      validatePasswordFields();
    }
    if (errors?.oldPassword) { validatePasswordFields(); }
    if (errors?.newPassword) {
      validatePasswordFields();
    }
  }, [confirmPassword, oldPassword]); // run when confirmPassword changes

  const validatePasswordFields = () => {
    const newErrors = {};
    if (!oldPassword.trim()) {
      newErrors.oldPassword = "Old password is required.";
    }
    if (!newPassword.trim()) {
      newErrors.newPassword = "New password is required.";
    }
    if (!confirmPassword.trim()) {
      newErrors.confirmPassword = "Please confirm your password.";
    }
    if (newPassword && confirmPassword && newPassword !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match.";
    }
    if (oldPassword && newPassword && oldPassword === newPassword) {
      newErrors.newPassword = "Old and new password cannot be the same.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };



  const handleChangePasswordSubmit = async (e) => {
    e.preventDefault();
    const isValid = validatePasswordFields();
    if (!isValid) return;
    // 🟢 Submit logic
    if (validatePasswordFields()) {
      try {
        const newload = {
          user_id: userData?.id,
          old_password: oldPassword,
          new_password: newPassword,
          new_password_confirmation: newPassword,
        };
        const response = await userChangepassword(newload);
        const data = await response.data;

        if (data) {
          Swal.fire({
            title: "Password changed successfully",
            icon: "success",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Ok",
          });
          // ✅ Clear and close modal after successful change
          setOldPassword('');
          setNewPassword('');
          setConfirmPassword('');
          setShowChangePasswordModal(false);
        }
      } catch (error) {
        Swal.fire({
          title: "Error",
          text: error?.response?.data?.message || error?.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    }
    // // Reset
    // setOldPassword('');
    // setNewPassword('');
    // setConfirmPassword('');
    // setErrors({});
    // setShowChangePasswordModal(false);
  };


  const fetchEvent = async () => {
    const response = await getAllDataWithFlag(6);
    let eventData = response?.data?.event?.filter((m) => (m?.is_deleted != 1));
    const upcoming = eventData?.filter((res) => (moment(res?.event_end_date).isAfter(moment())));
    if (upcoming?.length) setHasEvent(true);
    const newsresp = await getAllDataWithFlag(12);
    const newslength = newsresp?.data?.news?.filter((res) => (moment(res?.end_date).isAfter(moment())) && (res?.is_deleted == 1))?.length;
    if (newslength) setNews(newslength)
  }




  useEffect(() => {
    const admindata = JSON.parse(localStorage.getItem('usercre'));
    setuserData(admindata);
    fetchEvent();
  }, []);

  const navLinks = [
    { text: "Home", href: "/" },
    { text: "About Us", href: "/about" },
    // { text: "Our Work", href: "/work" },
    { text: "Projects", href: "/projects" },
    { text: "Publications", href: "/publications" },
    { text: "Gallery", href: "/gallery" },
    { text: "Events", href: "/events" },
    { text: "News", href: "#news" },
    { text: "Contact Us", href: "/contact" },
  ];

  // Handle sticky header on scroll
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Handle body scroll lock when menu is open
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [menuOpen]);

  return (
    <header
      className={`main-header main-header--four ${isSticky ? "sticky-header--cloned active" : "sticky-header--normal"
        }`}
    >
      <div className="topbar d-flex justify-content-between align-items-center">
        <div className="container topbar__content d-flex justify-content-between align-items-center w-100">
          <div className="topbar__left">
            <span>
              <i className="fas fa-phone"></i> +91-91722 46959
            </span>
            <span>
              <i className="fas fa-envelope"></i> admin@acwadam.org
            </span>
          </div>
          <div className="topbar__right align-items-center">
            <span>Follow us:</span>
            <a href="https://www.instagram.com/acwadam_/" target="_blank" className="social-icon"><i className="fab fa-instagram"></i></a>
            <a href="https://in.linkedin.com/in/acwadamorg" target="_blank" className="social-icon"><i className="fab fa-linkedin-in"></i></a>
            <a href="https://www.youtube.com/@acwadam1050" target="_blank" className="social-icon"><i className="fab fa-youtube"></i></a>
          </div>
        </div>
        {!userData && (
          <Button
            type="submit"
            className="btn btn-md loginbutton btn-warning ms-5 me-3"
            onClick={() => setShowLoginModal(true)}
          >
            Login
          </Button>
        )}
        {/* ✅ Show User section only if userData exists */}
        {userData && (
          <div className="user-section d-flex align-items-center ms-3 me-3">
            {/* <div className="mt-2 me-3">USER</div> */}
            <div className="avatar-placeholderuser">
              <span>{userData.name?.[0]?.toUpperCase()}</span>
            </div>
            <div className="dropdown-menu">
              <ul>
                <li >{userData.name}</li>
                <li onClick={() => setShowChangePasswordModal(true)}>Change Password</li>
                <li onClick={() => {
                  localStorage.removeItem('usercre');
                  window.location.reload(); // or navigate to login
                }}>Logout</li>
              </ul>
            </div>
          </div>
        )}
      </div>
      <Modal show={showChangePasswordModal} onHide={() => setShowChangePasswordModal(false)} centered>
        <Modal.Header closeButton style={{ backgroundColor: 'rgb(255, 152, 0)' }}>
          <Modal.Title>Change Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleChangePasswordSubmit} noValidate>
            <Form.Group className="mb-3">
              <Form.Label>
                Old Password <span className="text-danger">*</span>
              </Form.Label>
              <div style={{ position: 'relative' }}>
                <Form.Control
                  style={{ paddingRight: '2.5rem' }}
                  type={showOldPassword ? 'text' : 'password'}
                  value={oldPassword}
                  onChange={(e) => {
                    const val = e.target.value;
                    setOldPassword(val);
                    setErrors((prev) => ({
                      ...prev,
                      oldPassword: val.trim() ? '' : 'Old password is required.',
                      newPassword:
                        val === newPassword ? 'Old and new password cannot be the same.' : prev.newPassword,
                    }));
                  }}
                  isInvalid={!!errors.oldPassword}
                />
                <i
                  className={`bi ${errors.oldPassword ? 'bi-invalid' : ''} ${showOldPassword ? 'bi-eye-slash' : 'bi-eye'}`}
                  onClick={() => setShowOldPassword(!showOldPassword)}
                  style={{
                    position: 'absolute',
                    right: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                    fontSize: '1rem',
                    color: '#555',
                    zIndex: 2
                  }}
                ></i>
                <Form.Control.Feedback type="invalid">{errors.oldPassword}</Form.Control.Feedback>
              </div>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>
                New Password <span className="text-danger">*</span>
              </Form.Label>
              <div style={{ position: 'relative' }}>
                <Form.Control style={{ paddingRight: '2.5rem' }}
                  type={showNewPassword ? 'text' : 'password'}
                  value={newPassword}
                  onChange={(e) => {
                    const val = e.target.value;
                    setNewPassword(val);
                    let newPasswordError = '';
                    if (!val.trim()) {
                      newPasswordError = 'New password is required.';
                    } else if (val === oldPassword) {
                      newPasswordError = 'Old and new password cannot be the same.';
                    } else if (!strongPasswordRegex.test(val)) {
                      newPasswordError =
                        'Password must be at least 8 characters long, include uppercase, lowercase, number, and special character.';
                    }
                    setErrors((prev) => ({
                      ...prev,
                      newPassword: newPasswordError,
                      confirmPassword:
                        confirmPassword && confirmPassword !== val ? 'Passwords do not match.' : '',
                    }));
                  }}
                  isInvalid={!!errors.newPassword}
                />
                <i
                  className={`bi ${errors.newPassword ? 'bi-invalid mt-1' : ''} ${showNewPassword ? 'bi-eye-slash' : 'bi-eye'}`}
                  onClick={() => setShowNewPassword(!showNewPassword)}
                  style={{
                    position: 'absolute',
                    right: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                    fontSize: '1rem',
                    color: '#555',
                  }}
                ></i>
              </div>
              <Form.Control.Feedback style={{ display: 'block' }} type="invalid">{errors.newPassword}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>
                Confirm Password <span className="text-danger">*</span>
              </Form.Label>
              <div style={{ position: 'relative' }}>
                <Form.Control
                  type={showConfirmPassword ? 'text' : 'password'}
                  value={confirmPassword}
                  onChange={(e) => {
                    const val = e.target.value;
                    setConfirmPassword(val);
                    if (errors.confirmPassword) {
                      setErrors((prev) => ({ ...prev, confirmPassword: '' }));
                    }
                  }}
                  isInvalid={!!errors.confirmPassword}
                />
                <i
                  className={`bi ${errors.confirmPassword ? 'bi-invalid mt-1' : ''} ${showConfirmPassword ? 'bi-eye-slash' : 'bi-eye'}`}
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  style={{
                    position: 'absolute',
                    right: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                    fontSize: '1rem',
                    color: '#555',
                  }}
                ></i>
              </div>
              <Form.Control.Feedback style={{ display: 'block' }} type="invalid">{errors.confirmPassword}</Form.Control.Feedback>
            </Form.Group>


            <div className="text-end">
              <Button variant="secondary" onClick={() => setShowChangePasswordModal(false)}>Cancel</Button>{' '}
              <Button variant="primary" type="submit">Change Password</Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <div className="container">
        <div className="main-header__inner">
          <div className="main-header__logo">
            <Link to="/">
              <img src="/logo.png" alt="ACWADAM Logo" />
            </Link>
          </div>

          {/* Desktop Menu */}
          {!isAdminRoute && (
            <nav className="main-header__nav main-menu">
              <ul className="main-menu__list">
                {navLinks.map((link) => {
                  const isActive = location.pathname === link.href;

                  const handleClick = (e) => {
                    if (link.href.startsWith("#")) {
                      e.preventDefault();
                      const targetId = link.href.replace("#", "");
                      if (location.pathname === "/") {
                        // Already on home, scroll directly
                        const el = document.getElementById(targetId);
                        if (el) {
                          const yOffset = -280; // navbar height
                          const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
                          window.scrollTo({ top: y, behavior: "smooth" });
                        }
                      } else {
                        // Not on home, navigate to home and pass scroll info via state
                        navigate("/", { state: { scrollToId: targetId } });
                      }
                    }
                  };

                  return (
                    <li
                      key={link.text}
                      className={isActive ? "active" : link.text === "Events" && hasEvent ? "fluctuate" : ""}
                      onClick={handleClick}
                    >
                      {link.href.startsWith("#") ? (
                        <a href={link.href} className={isActive ? "active" : ""}>
                          {t(link.text)}
                          {link.text === "News" && news > 0 && (
                            <span className="ml-2 bg-red-500 px-2 py-0.5 rounded-full text-xs">
                              ({news})
                            </span>
                          )}
                        </a>
                      ) : (
                        <Link to={link.href} className={isActive ? "active" : ""}>
                          {t(link.text)}
                        </Link>
                      )}
                    </li>
                  );
                })}
              </ul>

            </nav>
          )}

          {/* Mobile Menu Toggle Button */}
          <div
            className="mobile-nav__btn mobile-nav__toggler"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <UserLogin
          show={showLoginModal}
          onHide={() => setShowLoginModal(false)}
          onShowRegister={() => {
            setShowLoginModal(false);
            setShowRegistrationModal(true);
          }}
        />
        <Registration
          show={showRegistrationModal}
          onHide={() => setShowRegistrationModal(false)}
        />
      </div>
      <div
        className={`mobile-menu-overlay ${menuOpen ? "active" : ""}`}
        onClick={() => setMenuOpen(false)}
      ></div>

      {/* Mobile Menu Slide Panel */}
      <div className={`mobile-menu-panel ${menuOpen ? "active" : ""}`}>
        <div className="mobile-menu-panel__header">
          <button
            className="mobile-menu-close"
            onClick={() => setMenuOpen(false)}
          >
            <i className="bi bi-x-lg" style={{ fontSize: "24px" }}></i>
          </button>
        </div>

        <div className="mobile-menu-panel__content">
          <nav className="mobile-menu-nav">
            <ul className="mobile-menu-nav__list">
              {navLinks.map((link) => {
                const isActive = location.pathname === link.href;

                const handleClick = (e) => {
                  if (link.href.startsWith("#")) {
                    e.preventDefault();
                    const targetId = link.href.replace("#", "");
                    if (location.pathname === "/") {
                      // Already on home, scroll directly
                      const el = document.getElementById(targetId);
                      if (el) {
                        const yOffset = -330; // navbar height
                        const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
                        window.scrollTo({ top: y, behavior: "smooth" });
                      }
                    } else {
                      // Not on home, navigate to home and pass scroll info via state
                      navigate("/", { state: { scrollToId: targetId } });
                    }
                  }
                };

                return (
                  <li key={link.text}>
                    {link.href.startsWith("#") ? (
                      <a
                        href={link.href}
                        className={location.hash === link.href ? "active" : ""}
                        onClick={(e) => {
                          handleClick(e, link);
                          setMenuOpen(false); // close mobile menu
                        }}
                      >
                        {t(link.text)}
                        {link.text === "News" && news > 0 && (
                          <span className="ml-2 bg-red-500 px-2 py-0.5 rounded-full text-xs">
                            ({news})
                          </span>
                        )}
                      </a>
                    ) : (
                      <Link
                        to={link.href}
                        className={location.pathname === link.href ? "active" : ""}
                        onClick={() => setMenuOpen(false)}
                      >
                        {t(link.text)}
                      </Link>
                    )}
                  </li>
                )
              })}
            </ul>
          </nav>

          <div className="mobile-menu-contact">
            <div className="mobile-menu-contact__item">
              <div className="contact-icon">
                <span className="icon-circle">@</span>
              </div>
              <a href="mailto:admin@acwadam.org">admin@acwadam.org</a>
            </div>

            <div className="mobile-menu-contact__item">
              <div className="contact-icon">
                <span className="icon-circle">✆</span>
              </div>
              <a href="tel:+919172244599">+91 91722 44599</a>
            </div>
          </div>

          <div className="mobile-menu-social">
            <a href="https://www.instagram.com/acwadam_/" target="_blank" className="social-icon"><i className="fab fa-instagram"></i></a>
            <a href="https://in.linkedin.com/in/acwadamorg" target="_blank" className="social-icon"><i className="fab fa-linkedin-in"></i></a>
            <a href="https://www.youtube.com/@acwadam1050" target="_blank" className="social-icon"><i className="fab fa-youtube"></i></a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
